import { Link } from "react-router-dom";

const pillars = [
  {
    title: "Ready for the AI Act",
    status: "Art. 50 live",
    text: "The Article 50 disclosure that binds a customer-facing assistant has applied since August 2026, and it ships built in. So do the logging and human checkpoints the high-risk regime will require from December 2027.",
  },
  {
    title: "Resilience-ready",
    status: "DORA",
    text: "Standard contract clauses, incident classification, and continuity targets that fit how your operational-risk team already works.",
  },
  {
    title: "Privacy by construction",
    status: "GDPR",
    text: "Only the data needed for the conversation enters the model. Explicit consent for anything remembered. EU-based storage by default.",
  },
];

export const CompliancePillars = () => (
  <section className="section dark" id="compliance">
    <div className="section-inner">
      <span className="section-eyebrow">Compliance, built in</span>
      <h2>Less paperwork. Less worry.</h2>
      <p className="lede">
        Banks have a long list of regulations to satisfy when they launch AI. Bancony
        ships with the evidence and controls your compliance team already expects, so
        most of the heavy lifting is done before you start.
      </p>

      <div className="compliance-triangle">
        {pillars.map((p) => (
          <div key={p.title} className="compliance-card">
            <span className="compliance-status">{p.status}</span>
            <h3>{p.title}</h3>
            <p>{p.text}</p>
            <Link to="/compliance" className="btn-arrow">More detail</Link>
          </div>
        ))}
      </div>
    </div>
  </section>
);
